/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PharmacySearchMode } from "./PharmacySearchMode";

export interface PharmacySearchRequest {
  /** Whether to search local retail or mail-order pharmacies */
  mode?: PharmacySearchMode;
  /** 5-digit ZIP code */
  zip?: string | null;
  /** Pharmacy name for mail-order searches */
  name?: string | null;
}
